import { render } from "./MatcherMsgDialog.vue?vue&type=template&id=0dff44e0&scoped=true"
import script from "./MatcherMsgDialog.vue?vue&type=script&lang=js"
export * from "./MatcherMsgDialog.vue?vue&type=script&lang=js"

import "./MatcherMsgDialog.vue?vue&type=style&index=0&id=0dff44e0&scoped=true&lang=css"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dff44e0"]])

export default __exports__